import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Contact from '../views/Contact.vue'
import OurStory from '../views/OurStory.vue'
import IBuzzPen from '../views/IBuzzPen.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/contact', name: 'contact', component: Contact },
  { path: '/our-story', name: 'our-story', component: OurStory },
  { path: '/ibuzzpen', name: 'ibuzzpen', component: IBuzzPen }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
